/* Produktbild-Lupe auf der Detailseite.
   Klick auf das Hauptbild öffnet eine 1:1-Box mit demselben Motiv; Pfeile
   blättern durch die Galerie, ESC/Backdrop schließen. Die Galerie bleibt die
   Quelle der Wahrheit: ein Pfeil klickt die passende Miniatur, danach wird die
   Adresse aus `data-src` übernommen (1400 px statt der 16:9-Kachel). */
(function () {
  var gal = document.querySelector('[data-gallery]');
  if (!gal) return;

  var media = gal.querySelector('.product__media');
  var hero = media && media.querySelector('img');
  if (!media || !hero) return;

  var ov = null;
  var ovBox, ovImg, btnPrev, btnNext, btnClose;
  var letzterFokus = null;
  var offen = false;

  function thumbs() {
    return Array.prototype.slice.call(gal.querySelectorAll('[data-gallery-thumb]'));
  }
  function aktivesThumb() {
    var t = gal.querySelector('[data-gallery-thumb][aria-current="true"]');
    return t || thumbs()[0] || null;
  }

  function zeigeBild(thumb) {
    if (!ovImg || !thumb) return;
    var bild = thumb.querySelector('img');
    var alt = bild ? (bild.alt || '') : '';
    ovImg.src = thumb.getAttribute('data-src') || hero.currentSrc || hero.src;
    ovImg.alt = alt;
    /* Nur echte Zeichnungen werden eingepasst. Detailfotos füllen die Box,
       auch wenn sie 16:9 sind — so bleibt die 1:1-Box randlos. */
    ovBox.classList.toggle('pzoom__box--doku', /technische\s+zeichnung/i.test(alt));
  }

  function baue() {
    ov = document.createElement('div');
    ov.className = 'pzoom';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Produktbild groß anzeigen');
    ov.innerHTML =
      '<button class="pzoom__close" type="button" aria-label="Schließen">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<button class="pzoom__nav pzoom__nav--prev" type="button" aria-label="Vorheriges Bild">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>' +
      '</button>' +
      '<figure class="pzoom__box"><img class="pzoom__img" alt=""></figure>' +
      '<button class="pzoom__nav pzoom__nav--next" type="button" aria-label="Nächstes Bild">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>' +
      '</button>';

    document.body.appendChild(ov);
    ovBox = ov.querySelector('.pzoom__box');
    ovImg = ov.querySelector('.pzoom__img');
    btnPrev = ov.querySelector('.pzoom__nav--prev');
    btnNext = ov.querySelector('.pzoom__nav--next');
    btnClose = ov.querySelector('.pzoom__close');

    btnClose.addEventListener('click', schliessen);
    btnPrev.addEventListener('click', function () { blaettern(-1); });
    btnNext.addEventListener('click', function () { blaettern(1); });
    ov.addEventListener('click', function (e) { if (e.target === ov) schliessen(); });
  }

  function oeffnen() {
    if (!ov) baue();
    letzterFokus = document.activeElement;
    var t = aktivesThumb();
    zeigeBild(t);
    var mehrere = thumbs().length > 1;
    btnPrev.hidden = !mehrere;
    btnNext.hidden = !mehrere;
    offen = true;
    document.body.classList.add('pzoom-offen');
    // Ein Frame Abstand, damit die Transition von 0 aus greift.
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    btnClose.focus({ preventScroll: true });
  }

  function schliessen() {
    if (!offen) return;
    offen = false;
    ov.classList.remove('is-open');
    document.body.classList.remove('pzoom-offen');
    window.setTimeout(function () {
      if (!offen) ovImg.removeAttribute('src');
    }, 260);
    if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true });
  }

  function blaettern(richtung) {
    var liste = thumbs();
    if (liste.length < 2) return;
    var aktuell = liste.indexOf(aktivesThumb());
    if (aktuell < 0) aktuell = 0;
    var naechster = (aktuell + richtung + liste.length) % liste.length;
    liste[naechster].click();
    window.setTimeout(function () { zeigeBild(aktivesThumb()); }, 40);
  }

  media.setAttribute('role', 'button');
  media.setAttribute('tabindex', '0');
  media.setAttribute('aria-label', 'Produktbild vergrößern');
  media.addEventListener('click', oeffnen);
  media.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      oeffnen();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!offen) return;
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); blaettern(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); blaettern(1); }
  });
})();
